import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

// 需使用插件一次
Vue.use(Vuex);

// 引入小仓库
import customer from './customer'
import phoneAddress from './phoneAddress';
import goodsId from './goodsId';

// 对外暴露Store类的一个实例
export default new Vuex.Store({
    plugins: [createPersistedState({
        storage: window.localStorage
    })],
    modules:{
        customer,
        phoneAddress,
        goodsId
    }
});